// src/components/Terms.jsx
import React from 'react';

function Terms() {
  return (
    <div className="policy-container">
      <h2>RediMD, LLC.</h2>
      <h4>Terms of Service</h4>
      
      <p>PATIENT UNDERSTANDING AS TO PRIMARY PRACTICE MEDICAL SERVICES BEING PROVIDED</p>
      
      <p>I understand that in receiving medical treatment thru RediMD:</p>
      
      <p>1. Such treatment is only for minor medical issues such as common illnesses or minor injuries. Examples
       include the following: flu, sinus infections, bronchitis, conjunctivitis, hypertension, diabetes,
       gastroenteritis, cellulitis, acne, alopecia, contact dermatitis, pharyngitis, contusions, strains,
       epicondylitis, urinary tract infections, allergies, and other common ailments that anti-bodies,
       anti-inflammatories and other non-narcotic prescriptions can cure. I recognize that receiving medical
       treatment thru RediMD is not for treatment of major illnesses.</p>
      
      <p>2. I am required to be honest by providing accurate and complete information about my past and current
       medical history and conditions. I recognize that RediMD is not affiliated or owned by my Employer. I
       recognize that my Employer is not offering medical treatment. I recognize that receiving medical treatment
       from a licensed doctor and/or nurse practitioner through RediMD is an alternative to receiving medical
       treatment from a physician in medical facilities. I agree receiving medical treatment from RediMD is
       voluntary and of my own free choice.</p>
      
      <p>3. RediMD staff will communicate with me through email, text messages and phone calls and I may choose either or both as my
      preferred contact in my profile. I cannot use RediMD services without agreeing to accept emails, text or phone calls.  RediMD 
      will never send marketing or sales information to me. 
      </p>
      <hr />
    </div>
  );
}

export default Terms;